import React, { Component } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import ContentBasePageHeaderActions from './ContentBasePageHeaderActions';

export default class ContentBasePageHeader extends Component {
  static Actions = ContentBasePageHeaderActions;

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    backHandler: PropTypes.func,
    children: PropTypes.node,
    hideBackHandler: PropTypes.bool,
    totalElements: PropTypes.number,
    isTitleLabel: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string
  };

  static defaultProps = {
    hideBackHandler: false,
    isTitleLabel: true
  };

  render() {
    const {
      title,
      subtitle,
      backHandler,
      hideBackHandler,
      isTitleLabel,
      children,
      className,
      contentClassName
    } = this.props;

    const contentBasePageHeaderClass = classNames(
      'content__base__page__header',
      className
    );

    const contentBasePageHeaderContentClass = classNames(
      'content__base__page__header__content',
      contentClassName
    );

    return (
      <div className="_mb-5 _mb-lg-7">
        <div className={contentBasePageHeaderClass}>
          <div className="content__base__page__title">
            {!hideBackHandler && (
              <ButtonIcon
                transparent
                size="small"
                icon="back"
                onClick={backHandler}
                className="content__base__page__back"
                type="button"
              >
                <I18n label="general.back" />
              </ButtonIcon>
            )}

            <h1 className="_text-gray-800">
              {isTitleLabel && title ? <I18n label={title} /> : title}
            </h1>

            {subtitle && (
              <div className="content__base__page__subtitle _text-gray-600 _pt-2">
                <I18n label={subtitle} />
              </div>
            )}
          </div>
          <div className={contentBasePageHeaderContentClass}>{children}</div>
        </div>
      </div>
    );
  }
}
